/**
 * Global Search - Arabic Translations
 */

export const globalSearchAr = {
  globalSearch: {
    title: 'بحث',
    placeholder: 'البحث في الطلبات والشحنات والمواقع...',
    shortcut: 'اضغط',
    shortcutKey: 'K',
    noResults: 'لم يتم العثور على نتائج',
    noResultsDescription: 'حاول تعديل مصطلحات البحث',
    loading: 'جاري البحث...',
    error: 'فشل البحث',
    minChars: 'اكتب حرفين على الأقل',
    results: {
      orders: 'الطلبات',
      salesOrders: 'أوامر البيع',
      shipments: 'الشحنات',
      locations: 'المواقع',
      visitors: 'الزوار',
      visits: 'الزيارات',
      gates: 'البوابات',
      zones: 'المناطق',
      drivers: 'السائقين',
      assets: 'الأصول',
      tenants: 'المستأجرين',
      invoices: 'الفواتير',
      products: 'المنتجات',
    },
    viewAll: 'عرض جميع النتائج',
    recent: 'عمليات البحث الأخيرة',
    clear: 'مسح',
  },
}
